import { pb } from './pocketbase';

// Rechercher des tuteurs par nom, email ou téléphone
export const searchTutors = async (query) => {
    try {
        if (!query || query.length < 2) {
            return [];
        }
        
        const result = await pb.collection('tutors').getList(1, 10, {
            filter: `first_name ~ "${query}" || last_name ~ "${query}" || email ~ "${query}" || phone ~ "${query}"`,
            sort: '-created'
        });
        
        return result.items;
    } catch (error) {
        console.error('Erreur lors de la recherche des tuteurs:', error);
        return [];
    }
};

export const getTutorsByCompany = async (companyId) => {
    if (!companyId) return [];
    try {
        const records = await pb.collection('tutors').getFullList({
            filter: `company_id = "${companyId}"`,
            sort: '-created',
        });
        return records;
    } catch (error) {
        console.error("Failed to get tutors by company:", error);
        throw error;
    }
};

export const createTutor = async (dataTutor) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const tutorWithPartnerId = {
                ...dataTutor,
                partner_id: pb.authStore.record.partner_id
            };
            const tutorRecord = await pb.collection('tutors').create(tutorWithPartnerId); 
            return tutorRecord;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le tutor sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error("Failed to create tutor:", error);
        throw error;
    }
};


export const updateTutor = async (id, dataTutor) => {
    try {
        const record = await pb.collection('tutors').update(id, dataTutor);
        return record;
    } catch (error) {
        console.error("Failed to update tutor:", error);
        throw error;
    }
};


export const deleteTutor = async (id) => {
    try {
        await pb.collection('tutors').delete(id);
    } catch (error) {
        console.error("Failed to delete tutor:", error);
        throw error;
    }
};
